import {
  redoMarketCountryIdFormat,
  redoMarketIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { pricingInclusionMode } from "./pricing-inclusion-mode";
import { marketWithCountriesOutput } from "./redo-market";

const countryCode = z
  .string()
  .regex(/^[A-Z]{2}$/, "Must be ISO 3166-1 alpha-2 uppercase");

const countryInput = z.object({
  /** Existing publish target to keep; omit for net-new countries, which get
   * their Shopify market/catalog/price list provisioned on save. */
  id: redoMarketCountryIdFormat.schema.optional(),
  destinationCountryCode: countryCode,
});

/**
 * Upsert a market's policy fields plus its full set of country rows.
 * Omit `marketId` to create. Country rows missing from the input list are
 * soft-deleted. Markup rate is a decimal-string multiplier ("1.000000" = no
 * markup).
 */
export const upsertRedoMarket = {
  name: "upsertRedoMarket" as const,
  input: z.object({
    marketId: redoMarketIdFormat.schema.optional(),
    enabled: z.boolean().optional(),
    inclusionMode: pricingInclusionMode.optional(),
    markupRate: z.string().optional(),
    countries: z.array(countryInput),
  }),
  output: marketWithCountriesOutput,
};
